import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=73974fdc&"
import script from "./Awards.vue?vue&type=script&lang=js&"
export * from "./Awards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vincent/Documents/Développement/Stadia Fr/Jeux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73974fdc')) {
      api.createRecord('73974fdc', component.options)
    } else {
      api.reload('73974fdc', component.options)
    }
    module.hot.accept("./Awards.vue?vue&type=template&id=73974fdc&", function () {
      api.rerender('73974fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/javascripts/pages/site/Awards.vue"
export default component.exports